import React from 'react';
import {Grid, Skeleton, Typography} from '@mui/material';
import {ILabeledRowField} from './labeled-row-field';

const getContent = (text: string | boolean | undefined | number, textTransform: string | undefined , children: React.ReactNode) => {
  if (text) {
    return (
        <Typography sx={styles.text(textTransform || 'initial')}>{text}</Typography>
    )
  }
  else {
   return (children || '-');
  }
}

export const LabeledRowField = ({label, disableLabel = false, isLoading, text, textTransform, children}: ILabeledRowField) => {
  return (
    <Grid sx={styles.box} container>
      {!disableLabel && (
        <Grid xs={6} sx={{display: 'flex'}} item>
          <Typography sx={styles.label}>{label}</Typography>
        </Grid>
      )}
      <Grid xs={!disableLabel ? 6 : 12} item>
        {!isLoading ? getContent(text, textTransform, children) : <Skeleton sx={{width: '80%'}} />}
      </Grid>
    </Grid>
  );
};

const styles = {
  box: {
    width: '100%'
  },
  label: {
    color: '#98A2B3',
    fontSize: '0.75rem',
    textTransform: 'uppercase',
    fontFamily: 'OpenSansBold',
    my: 'auto'
  },
  text: (textTransform: string) => ({
    color: '#1D2939',
    fontSize: '1rem',
    textTransform,
    fontFamily: 'OpenSansRegular',
    overflowWrap: 'break-word',
    wordWrap: ' break-word',
    hyphens: 'auto'
  })
};

export default LabeledRowField;
